import * as yup from 'yup';

const type = yup.string()
  .required('type.error')
  .oneOf(['PRIMARY'], 'type.error');

const language = yup.string()
  .required('language.error')
  .oneOf(['DE'], 'language.error');

export {
  type,
  language,
};

